import varAxios from "../../Comman/axios";
import { getNotificationUrl,notificationCountUrl, UpdateUnReadNotificationUrl } from '../../Comman/apiEndPoints';

export const Fetch_All_Notification_Data = "Fetch_All_Notification_Data";
export const Fetch_Count = "Fetch_Count";
export const Handle_Notifi_Error = "Handle_Notifi_Error";

export function getNotificationCount() {
    let requestPayload = {
        UserCategoryId : 3
    }
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem('id_super_admin_token')
      }
    return (dispatch) => {
        return varAxios.post(notificationCountUrl, requestPayload,
            {headers : headers},
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                if(response.data.statusCode == 200){
                    dispatch(
                        fetchCount(response.data.countNotification)                    
                    );
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }
}
export function fetchCount(count) {
    return {
        type : Fetch_Count,
        count
    }
}
export function getAllNotification(requestPayload) {
    return (dispatch) => {
        return varAxios.post(getNotificationUrl, requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    fetchAllNotificationData({
                        message : response.data.errorMessage,
                        errorCode: response.data.errorCode,
                        statusCode: response.data.statusCode,
                        list : response.data.notificationList,
                        countValue : response.data.countNotification.CountValue
                    })
                );
            })
            .catch((error) => {
                dispatch(
                    handleError(error.response.data.errorCode,error.response.data.errorMessage,
                        error.response.data.statusCode)
                )
            })
    }
}
export function handleError(errorCode,errorMessage,statusCode){
    return {
        type : Handle_Notifi_Error,
        errorCode,
        errorMessage,
        statusCode
    }
}
export function fetchAllNotificationData({message,errorCode,statusCode,list,countValue}) {
    return {
        type : Fetch_All_Notification_Data,
        message,
        errorCode,
        statusCode,
        list,
        countValue
    }
}
export function updateUnReadNotification(requestPayload) {
    return (dispatch) => {
        return varAxios.post(UpdateUnReadNotificationUrl, requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    fetchAllNotificationData({
                        message : response.data.errorMessage,
                        errorCode: response.data.errorCode,
                        statusCode: response.data.statusCode,
                        list : response.data.notificationList
                    })
                );
            })
            .catch((error) => {
                console.log(error)
            })
    }
}
